'use strict';

import React, { Component } from 'react';
import Image from './image.jsx';
import { isEmpty } from "lodash";
import { Grid } from "@material-ui/core";


export default class ImageList extends React.Component {
    state = {
    }

    render() {
        console.log(this.props.imageList);
        const { imageList } = this.props;
        return (
            <Grid container spacing={2}>
                {!isEmpty(imageList) && imageList.map( image => (
                        <Image key={image} src={image} />
                    ) )
                }
            </Grid>
        )
    }
}
